import React from 'react';
import {
  Box, Card, makeStyles, Typography
} from '@material-ui/core';
import IconRenderer from './IconRenderer';

const useStyles = makeStyles((theme) => ({
  iconBox: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  miniCard: {
    cursor: 'pointer',
    '&:hover': {
      transform: 'scale(1.05)',
    },
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
  },
}));

interface Props {
  icon: string,
  label: string,
  description: string,
  onClick?: () => void,
}

const MiniCard = ({
  icon,
  label,
  description,
  onClick,
}: Props) => {
  const classes = useStyles();
  return (
    <Card className={classes.miniCard} onClick={onClick}>
      <Box display="flex" alignItems="center">
        <Box p={2} className={classes.iconBox}>
          <IconRenderer iconName={icon} />
        </Box>
        <Box ml={2}>
          <Typography variant="h6">
            {label}
          </Typography>
          <Typography variant="caption">
            {description}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default MiniCard;
